import { render, staticRenderFns } from "./VueSample.vue?vue&type=template&id=68bd9ed4&scoped=true&"
import script from "./VueSample.vue?vue&type=script&lang=js&"
export * from "./VueSample.vue?vue&type=script&lang=js&"
import style0 from "./VueSample.vue?vue&type=style&index=0&id=68bd9ed4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bd9ed4",
  null
  
)

export default component.exports